export const AGGREGATION_ACTION_DIALOG_TITLE =
  'Agrégation des prestations dans Pennylane';

export function isAggregationActionDialogNeeded(
  selectedAction:
    | Readonly<{
        settings: Readonly<{
          showServiceUsageAggregationDialog?: boolean | null;
        }>;
      }>
    | undefined,
): boolean {
  return !!selectedAction?.settings.showServiceUsageAggregationDialog;
}

export function isAggregationChoiceValid(aggregationLevel: unknown): boolean {
  return aggregationLevel !== undefined;
}
